@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';
@import '../../../../../constants/spacing.module.less';

.modal-body {
  margin-left: @space-48;
  margin-right: @space-48;
  margin-top: @space-16;
}

.error-modal {
  width: 420px;
}

.loading-indicator {
  height: 120px;
}

.description {
  margin: @space-0;
  padding: @space-0;
  font-size: 12px;
  font-weight: @normal;
  line-height: 12px;
  color: var(--default--disabled--text-color--4);
}

.require {
  margin-top: @space-16;
  margin-bottom: @space-16;
  cursor: pointer;
}

.no-carriers {
  margin-top: 40px;
  margin-bottom: 40px;
}

.slider-description {
  margin-left: @space-4;
  font-size: 14px;
  font-weight: @normal;

  a {
    color: var(--primary--link--text-color--2);
  }
}

.checkbox-slider {
  margin-top: 2px;
}

.modal-footer {
  line-height: 16px;
  min-height: 80px;
}

.footer-button-group {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  height: 100%;
  padding-bottom: @space-16;

  > button {
    margin-left: 5px;
  }
}

.apply {
  position: absolute;
  left: @space-16;
  cursor: pointer;
  margin-top: @space-48;
  margin-bottom: @space-16;
}

.modification-date {
  position: absolute;
  margin-top: @space-16;
  font-size: 12px;
  font-weight: @normal;
  line-height: 12px;
  color: var(--default--disabled--text-color--4);
}

.radio-list {
  display: flex;
  margin-top: @space-24;

  .radio-item {
    margin-right: @space-32;
    padding: @space-0;
  }
}
